import React,{useState} from 'react';
import "./navbar.css";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

function Navbar(){

    const [isVisible, setIsVisible] = useState(false);
    const [isToggled, setIsToggled] = useState(false);//for transition to work

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
        setIsToggled(!isToggled);
    };


    return(
        <div className="navbar">
            <h1 className="navbar-h1" data-aos="fade-down" data-aos-duration="600" data-aos-delay="500">AKSHAT.</h1>
            <li className={`header-li ${isToggled ? 'open' : ''}`}>
                <a className="header-anchor" href="#Home" data-aos="fade-down" data-aos-duration="600" data-aos-delay="700">Home</a>
                <a className="header-anchor" href="#About" data-aos="fade-down" data-aos-duration="600" data-aos-delay="900">About</a>
                <a className="header-anchor" href="#Portfolio" data-aos="fade-down" data-aos-duration="600" data-aos-delay="1100">Portfolio</a>
                <a className="header-anchor" href="#Contact" data-aos="fade-down" data-aos-duration="600" data-aos-delay="1300">Contact</a>
            </li>

            <div className="ms-header-toggler-div"  onClick={toggleVisibility}>
                {isToggled?<CloseIcon className="ms-header-navbar-toggler"/>:<MenuIcon className="ms-header-navbar-toggler"/>}
            </div>
            
            {isVisible &&
            <>
                <div className={`ms-header-mobile-div ${isToggled ? 'open' : ''}`}>
                    <div className="header-div">
                        <div className='navbar-div-1'>
                            <a className="header-anchor-mob" href="#Home">Home</a>
                        </div>
                        <div className='navbar-div-1'>
                            <a className="header-anchor-mob" href="#About" >About</a>
                        </div>
                        <div className='navbar-div-1'>
                            <a className="header-anchor-mob" href="#Portfolio" >Portfolio</a>
                        </div>
                        <div className='navbar-div-1'>
                            <a className="header-anchor-mob" href="#Contact">Contact</a>
                        </div>
                    </div>
                </div>
            </>
            }
        </div>
    );
}

export default Navbar;